<rx-rich-dropdown
  autoClose="outside"
  [placement]="placement"
  [selectStyle]="true"
  (dropdownOpenChange)="resetCheckboxes()"
  [compact]="compact"
  [extraCompact]="extraCompact"
  [showHeader]="showDropdownHeader"
  [highlight]="highlight"
>
  <ng-container host>
    @if (icon) {
      <rx-icon [name]="icon" class="mr-2" [fill]="highlight ? 'primary-darker' : 'grey-darker'" />
    }
    <span>{{ placeHolder }}</span>
  </ng-container>
  @if (title) {
    <ng-container menuLabel>{{ title }}</ng-container>
  }
  <rx-checkboxes content [options]="checkboxesState"></rx-checkboxes>
  <div footer class="btn-group">
    <rx-button data-qa="test-checkboxes-dropdown-cancel-button" buttonClass="subtle mr-3" (click)="closeDropdown()">
      {{ cancelText }}
    </rx-button>
    <rx-button data-qa="test-checkboxes-dropdown-apply-button" buttonClass="primary" (click)="apply()"
      >{{ applyText }}
    </rx-button>
  </div>
</rx-rich-dropdown>
